import { useTasksController_unignoreTask } from '@/services/hooks';

import { ignoreBody, useMappedMutation } from '../shared/mutation';

import type { UnignoreTaskVariables, UseUnignoreTaskResult } from './types';

function unignoreTaskToApi(variables: UnignoreTaskVariables) {
    return { taskId: variables.taskId };
}

export const useUnignoreTask = (): UseUnignoreTaskResult =>
    useMappedMutation(useTasksController_unignoreTask(), unignoreTaskToApi, ignoreBody);
